<ejs-grid #gridViewBatch [dataSource]="ViewBatchData | async" [allowResizing]="true" allowPaging="true"
[pageSettings]="initialPage" [allowFiltering]="true" [allowSorting]="true"
(actionBegin)="onActionComplete($event)" [showColumnChooser]="true" 
[filterSettings]="filterSettings" (dataStateChange)="dataStateChange($event)">
<e-columns>
    <e-column minWidth="200" headerText="Action" uid="action" textAlign="center"
        [showInColumnChooser]="false">
        <ng-template #template let-data>
            <button class="btn btn-edit-table text-center me-2" (click)="getclaimID(data.id)" >
                <i class="fa fa-download"></i>
            </button>    
            <button class="btn btn-edit-table text-center ms-2" (click)="showReport(data)" >
                <i class="fa fa-eye"></i>
            </button>       
        </ng-template>
    </e-column>
    <e-column minWidth="200" field="generatedDate" type="date" headerText="Generated Date"
    [format]="formatOptions"></e-column>

    <e-column minWidth="200" field="interchangeControlNumber" type="string" headerText="InterchangeControlNumber" [allowSorting]="false">
        <ng-template #filterTemplate let-data>
            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
        </ng-template>
    </e-column>

    <e-column minWidth="200" field="clearingHouseName" headerText="Clearing House" type="string"
        [allowFiltering]="false">
        <ng-template #filterTemplate let-data>
            <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
        </ng-template>
    </e-column>  
   
</e-columns>

</ejs-grid>

<span id="openReportModal" data-bs-toggle="modal" data-bs-target="#viewReport"></span>
<div class="modal fade " id="viewReport" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header">Export Clamis EDI-837</h5>
          <div class="text-right">
            <button class="btn blue-btn btn-sm mr-2" (click)="closemodal()">
              Close</button>
          </div>
        </div>
        <div class="modal-body" style="height:600px">
          <ng-container *ngIf="reportContain == true">
            <div style="width: 100%;height:100%" #reportContainer></div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>


